"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageActions = exports.PageNames = void 0;
var PageNames;
(function (PageNames) {
    PageNames["FIND_SHIFTS"] = "LSSFind_Shifts";
    PageNames["SCHEDULES"] = "LSSSchedules";
    PageNames["SHOW_SCHEDULE"] = "LSSShow_Schedule";
    PageNames["DASHBOARD"] = "LSSDashboard";
    PageNames["MY_SCHEDULE"] = "LSSMy_Schedule";
    PageNames["SHIFT_DETAIL"] = "Shift Detail";
    PageNames["MAIN"] = "Main";
    PageNames["REWARD_STATUS"] = "Reward Status";
    PageNames["MONTHLY_CALENDAR"] = "Monthly calendar";
    PageNames["WEEKLY_CALENDAR"] = "Weekly calendar";
    PageNames["LOCATION_ELIGIBILITY"] = "Location Eligibility";
    PageNames["FILTERS"] = "Filters";
    PageNames["SWAP"] = "Swap";
    PageNames["DAY_ONE"] = "Day_One";
})(PageNames = exports.PageNames || (exports.PageNames = {}));
var PageActions;
(function (PageActions) {
    PageActions["EXPAND"] = "expand";
    PageActions["DATE_CHANGE"] = "date-change";
    PageActions["REPORT_PUNCH"] = "report-punch";
    PageActions["VIEW_FILTER"] = "view-filter";
    PageActions["UPDATE_FILTERS"] = "update-filters";
    PageActions["ADD_SHIFT"] = "add-shift";
    PageActions["ADD_SHIFT_FAILURE"] = "add-shift-failure";
    PageActions["CONFIRM_ADD_SHIFT"] = "confirm-add-shift";
    PageActions["DROP_SHIFT"] = "drop-shift";
    PageActions["DROP_SHIFT_FAILURE"] = "drop-shift-failure";
    PageActions["CONFIRM_DROP_SHIFT"] = "confirm-drop-shift";
    PageActions["SURGE_PAY_UPDATE"] = "surge-pay-update";
    PageActions["START_TIME_UPDATE"] = "start-time-update";
    PageActions["UNAVAILABILITY_UPDATE"] = "unavailability-update";
    PageActions["LOCATION_UPDATE"] = "location-update";
    PageActions["JOB_CATEGORY_UPDATE"] = "job-category-update";
    PageActions["CLOSE_FILTER_DRAWER"] = "close-filter-drawer";
    PageActions["RESET_FILTERS"] = "reset-filters";
    PageActions["INSTANT_SWAP"] = "instant-swap";
    PageActions["INSTANT_SWAP_SUCCESS"] = "instant-swap-success";
    PageActions["INSTANT_SWAP_FAILURE"] = "instant-swap-failure";
    PageActions["SWAP_REQUEST"] = "swap-request";
    PageActions["SWAP_REQUEST_SUCCESS"] = "swap-request-success";
    PageActions["SWAP_REQUEST_FAILURE"] = "swap-request-failure";
    PageActions["CANCEL_SWAP"] = "cancel-swap";
    PageActions["CANCEL_SWAP_SUCCESS"] = "cancel-swap-success";
    PageActions["CANCEL_SWAP_FAILURE"] = "cancel-swap-failure";
    PageActions["WIDGET_CLICKED"] = "widget-clicked";
    PageActions["WIDGET_ERROR"] = "widget-error";
    PageActions["TOGGLE_TO_WEEKLY_CALENDAR"] = "toggle-to-weekly-calendar";
    PageActions["TOGGLE_TO_MONTHLY_CALENDAR"] = "toggle-to-monthly-calendar";
    PageActions["CLOSE_SHIFT_DETAIL"] = "close-shift-detail";
    PageActions["PAY_BREAKDOWN_CLICKED"] = "pay-breakdown-clicked";
    PageActions["PAID_HOURS_CLICKED"] = "paid-hours-clicked";
    PageActions["WAGE_STATEMENT_CLICKED"] = "wage-statement-clicked";
})(PageActions = exports.PageActions || (exports.PageActions = {}));
